import {gql, useLazyQuery} from "@apollo/client";

const GET_SANCTIONS = gql`
query SanctionsBySeason($seasonId: Int!, $page: Int, $pageSize: Int) {
    sanctionsBySeason(seasonId: $seasonId, page: $page, pageSize: $pageSize) {
        objects {
            id
            type
            reason
            status
            notes
            gamesSuspended
            issuedAt
            profile {
                id
                fullName
            }
            team {
                id
                name
            }
            game{
                id
                name
            }
        }
        page
        pages
        hasNext
        hasPrev
    }
}
`;

export default function GetSanctions() {
    return useLazyQuery(GET_SANCTIONS);
};
